import Vue from 'vue'
import App from './App.vue'
import api from "./utils/api";
import wx from 'weixin-js-sdk';
import { Toast, Icon, Button  } from "vant";
import { Form, Field, CellGroup,Picker,Popup   } from 'vant';


Vue.prototype.$api = api;
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Popup);
Vue.prototype.wx=wx/*  */


require('@/ui/index')

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
